import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirportShuttleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airport_shuttle"}/>
}
